import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFLightning } from '@/components/UI/svg/ProductStatic';

export default function Comp({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_max_static');

    return (
        <div className={`${css.gsapdGroupB} gsapdGroupB`}>
            <div className="msg-lineA msg-lineA1">{t('Fast')}</div>
            <div className="msg-b-mod-out">
                <div className="msg-b-mod">
                    <div className="msg-b-mod-bg">
                        <EFLightning />
                    </div>
                    <div className="msg-b-mod-msgbox">
                        <div className="msg-b-mod-a">
                            <div className="msg-a-line1">{t('Up to')}</div>
                            <div className="msg-a-line2">{t('3600W')}</div>
                        </div>
                        <div className="msg-b-mod-b">
                            <div className="msg-b-line1">{t('lightning_desc1')}</div>
                            <div className="msg-b-line2">{t('lightning_desc2')}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="msg-lineA msg-lineA1">{t('Charging')}</div>
        </div>
    );
}
